import React from 'react';
import { Button } from '@mantine/core';
import { HelpCircle } from 'lucide-react';

interface FeedbackButtonProps {
  onClick: () => void;
  variant?: 'sidebar' | 'fixed';
}

export const FeedbackButton: React.FC<FeedbackButtonProps> = ({ onClick, variant = 'sidebar' }) => {
  if (variant === 'sidebar') {
    return (
      <div style={{ padding: '12px 16px' }}>
        <Button
          onClick={onClick}
          variant="subtle"
          size="xs"
          fullWidth
          leftSection={<HelpCircle size={14} />}
          style={{
            color: 'var(--app-text-muted)',
            justifyContent: 'flex-start',
            fontSize: '12px',
            height: '32px',
          }}
        >
          Help & Feedback
        </Button>
      </div>
    );
  }

  // Legacy fixed position variant (keeping for backwards compatibility)
  return (
    <div
      style={{
        position: 'fixed',
        bottom: '24px',
        right: '24px',
        zIndex: 1000,
      }}
    >
      <Button
        onClick={onClick}
        size="md"
        radius="xl"
        variant="filled"
        leftSection={<HelpCircle size={16} />}
        style={{
          backgroundColor: 'var(--app-primary, #3b82f6)',
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
          transition: 'all 0.2s ease',
          cursor: 'pointer',
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.transform = 'scale(1.05)';
          e.currentTarget.style.boxShadow = '0 6px 16px rgba(0, 0, 0, 0.2)';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = 'scale(1)';
          e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.15)';
        }}
      >
        Help & Feedback
      </Button>
    </div>
  );
};